import { callAPI } from '../network';

export async function getPersonsByAirportId (EmployeeId){
  
   const data = await callAPI(
                        null, 
                        'EmployeePosition', 'get');
   return data || [ ];
}


export async function saveCampaignTargets (targets){
    const data = await callAPI(targets, 'Campaign/UpdateDataCampaign', 'post');
    return data;
}

export async function getCampaignContentTypes (){
  
    const data = await callAPI(
                         null, 
                         'Campaign/GetAllCampaignContentTypes', 'get');
    return data || [ ];
}


export async function getCampaigns (EmployeeId, companyId){
  
    const data = await callAPI(
        null, 
         `Campaign?EmployeeId=${EmployeeId}&companyId=${companyId}`, 'get');
    return data || [ ];
}


export async function getCampaignStates (){
  
    const data = await callAPI(
                         null, 
                         'Campaign/GetAllCampaignStates', 'get');
    return data || [ ];
}

export async function getActivityCampaign (EmployeeId, CompanyId){
  
    const data = await callAPI(
                        null, 
                         `Campaign/GetAllCampaignActivitysByEmployeeId?employeeId=${EmployeeId}&companyId=${CompanyId}`, 'get');
    return data || [ ];
 }


 export async function saveDataRegisterActivity (employeeId, activityId, personResponsibleId){
    const parameters = {
       EmployeeId: employeeId,
       ActivityId: activityId,
       PersonResponsibleId: personResponsibleId
     }
 
    const data = await callAPI(
                         parameters, 
                         'Campaign/SaveRegisterActivityCampaign', 'post');
    return data;
 }

 export async function getDataSelectedCampaign (id){

    const data = await callAPI(
                         null, 
                         'Campaign/GetById?id='+ id, 'get');
    return data;
 }


 export async function getReportState (id){

    const data = await callAPI(
                         null, 
                         'Campaign/GetReportState?id='+ id, 'get');
    return data;
 }

 export async function getAllDataEmployeesByAirportAndCompany(id, companyId){

    const data = await callAPI(
                         null, 
                         `Campaign/GetAllDataEmployeesByAirportAndCompany?AirportID=${id}&companyId=${companyId}`, 'get');
    return data;
 }
